const LEADERBOARD_VALUE_KEYS = Object.freeze({
  totalWork: 'work',
  totalWorkouts: 'workoutCount',
  averageWork: 'averageWork',
  gems: 'gems',
  individualRaid: 'raidPointsContributed',
  lifetimeXp: 'lifetimeXp',
  seasonXp: 'seasonxp',
  streaks: 'streak',
  userScore: 'progressValue',
  bestSessionWork: 'sessionWork',
  teamRaid: 'raidPoints',
});

const toSafeNumber = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const normalizeLeaderboardEntries = (data) => {
  if (Array.isArray(data)) {
    return data;
  }

  if (!data || typeof data !== 'object') {
    return [];
  }

  return Object.entries(data).map(([username, entry]) => ({
    ...entry,
    username: entry?.username ?? username,
    fullName: entry?.fullName ?? entry?.full_name ?? '',
    profilePicUrl: entry?.profilePicUrl ?? entry?.profile_pic_url ?? '',
  }));
};

export const getLeaderboardValueForCategory = (entry, category) => {
  const valueKey = LEADERBOARD_VALUE_KEYS[category];
  if (!valueKey || !entry) {
    return null;
  }

  return toSafeNumber(entry[valueKey]);
};

export const findLeaderboardEntryForUser = (entries, userId, username) => {
  const safeEntries = normalizeLeaderboardEntries(entries);
  const safeUserId = String(userId ?? '');
  const safeUsername = String(username ?? '').toLowerCase();

  return (
    safeEntries.find((entry) => String(entry?.id ?? '') === safeUserId) ??
    safeEntries.find((entry) => String(entry?.username ?? '').toLowerCase() === safeUsername) ??
    null
  );
};
